<template>
  <require from="framework/value_converters/date-and-time"></require>
  <require from="controls/bs-form-input"></require>
  <require from="controls/bs-form-switch"></require>

  <div>
    <h6 class="${!model.isActive ? 'sc-archived' : ''}"><i class="${model.icon}" style="margin-right: 5px;"></i>${model.name}</h6>
    <div class="form-row">
      <div class="col-md-6 ${!model.isActive ? 'sc-archived' : ''}">
        <bs-form-input type="text" label="Accommodation Type Name" placeholder="Accommodation type name" value.bind="model.name & validate" disabled.bind="!model.isActive" maxlength="500"></bs-form-input>
      </div>
      <div class="col-md-6" if.bind="!model.archivedOn">
        <bs-form-input type="text" label="Accommodation Type Icon" placeholder="Accommodation type icon" value.bind="model.icon & validate" maxlength="100"></bs-form-input>
      </div>
      <div class="col-md-3 sc-archived" if.bind="model.archivedOn">
        <bs-form-input type="text" label="Accommodation Type Icon" placeholder="Accommodation type icon" value.bind="model.icon & validate" maxlength="100" disabled.bind="true"></bs-form-input>
      </div>
      <div class="col-md-3" if.bind="model.archivedOn">
        <bs-form-input type="text" label="Archived by ${model.archivedBy.fullName || model.archivedBy.loginName}" value.bind="model.archivedOn | dateTime" disabled="true"></bs-form-input>
      </div>
    </div>
    <div class="form-row">
      <div class="col-md-6 ${!model.isActive ? 'sc-archived' : ''}">
        <bs-form-switch text="Travel Request" checked.bind="model.isForTravelRequest" disabled.bind="!model.isActive"></bs-form-switch>
      </div>
      <div class="col-md-6 ${!model.isActive ? 'sc-archived' : ''}">
        <bs-form-switch text="Holiday Trip" checked.bind="model.isForHolidayTrip" disabled.bind="!model.isActive"></bs-form-switch>
      </div>
    </div>
  </div>
</template>
